import React from "react";
import Dropdown from "./Dropdown";
import {useTranslation} from "react-i18next";
import {statusIcons} from "./index";
import Stack from "@mui/material/Stack";
import {StyledInput} from "./cell";

const identity = (x) => x;

const EditableHeader = ({header, label, options, renderOptions, getOptionValue, renderValue, onChange}) => {
    const isEditing = header.table.options?.meta?.multipleEditing;
    const table = header.table;
    const columnId = header.column.id;

    if(!isEditing) {
        return <span>{label}</span>
    } else{
        return <Stack>
            <span>{label}</span>
            {
                options ?
                    <Dropdown value={table.options.meta.headersState.headers[columnId]}
                              renderOptions={renderOptions || identity}
                              getOptionValue={getOptionValue || identity}
                              renderValue={renderValue || identity}
                              options={options}
                              onSelect={(value) => onChange(table, columnId, value)}/>
                    :
                    <StyledInput value={table.options.meta.headersState.headers[columnId] ?? ""}
                                 type="number"
                                 onChange={(event) => onChange(table, columnId, event.target.value)}/>
            }
        </Stack>
    }
}

export const EditableStatusHeaderCell = ({onChange, header}) => {
    const {t} = useTranslation("models1");
    const renderValue = (value) => value ? statusIcons[value] : "-"

    const options = ["OPEN", "CLOSED", "CONFIRMED"]

    const renderOptions = (value) => (<Stack direction="row" spacing={1}>
            {statusIcons[value]}
            <span>{t(`enums:model1Status.${value}`)}</span>
        </Stack>
    )

    return <EditableHeader header={header}
                           label={t(`table.status`)}
                           onChange={onChange}
                           options={options}
                           renderOptions={renderOptions}
                           renderValue={renderValue}
                           getOptionValue={(option) => option}/>
}


export const EditableParamHeaderCell = ({onChange, header, label}) => {
    const {model1Registry} = header.table?.options?.meta ?? {};
    const columnId = header.column.id;
    const options = model1Registry?.[columnId];
    const renderValue = (value) => value ? value : "-"

    return <EditableHeader header={header}
                           label={label}
                           onChange={onChange}
                           options={options}
                           renderValue={renderValue}
                           renderOptions={(option) => `${option.code} - ${option.observation}`}
                           getOptionValue={(option) => option.code}
    />
}


export default EditableHeader;